import { Extractor } from "./../types";

export default class InputExtractor implements Extractor {
  extract(target: HTMLElement): Record<string, unknown> {
    const input = target.closest("input, textarea");

    if (input instanceof HTMLInputElement) {
      let value: boolean | string;

      if (input.type === "checkbox") {
        value = input.checked ? "Yes" : "No";
      } else {
        value = input.value;
      }

      return {
        name: input.name || undefined,
        value,
        type: input.type,
      };
    }

    if (input instanceof HTMLTextAreaElement) {
      return {
        name: input.name || undefined,
        value: input.value,
        type: "textarea",
      };
    }

    return {};
  }
}
